import { format, parseJSON } from 'date-fns';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { MdClose, MdKeyboardBackspace } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { SUCCESS } from '../../../assets/images';
import BottomSheet from '../../../components/Bottomsheet';
import Calender from '../../../components/Calender/Calender';
import CalenderProvider from '../../../components/Calender/CalenderContext';
import { useAppSelector } from '../../../hooks';
// import { ITrialClass } from '../../../interfaces/Trial';
import { Button } from '@wot/components';
import {
  IHobby,
  IHobbyType,
  ILevels,
  IProfessionSubject,
  ISkill,
  ISkillType,
  ITrialClass,
  ITutor,
  ITutorProfessionCategory
} from '@wot/typings';
import { AddPayload, sessionsApi } from '../../../api/sessions';
import xhr from '../../../utils/fetch';
export interface ITimeSlot {
  start: string;
  end: string;
}

const getBoards = (categories: ITutorProfessionCategory<IProfessionSubject>[]) => {
  let o = _.flatten(categories.map((i) => i.board));
  const y = _.uniqBy(o, 'name');
  return y.map((item) => item.name);
};

const getGradesFromBoard = (categories: ITutorProfessionCategory<IProfessionSubject>[], board: string) => {
  let o = _.flatten(categories.map((i) => i.board));
  let x = o.filter((item) => item.name === board);
  return _.uniq(x.flatMap((item) => item.grades));
};

const getSubjectsFromGrade = (
  categories: ITutorProfessionCategory<IProfessionSubject>[],
  board: string,
  grade: string
) => {
  let o = _.flatten(
    categories.filter((i) => {
      // @ts-ignore
      let x = i.board.find((item) => item.name === board && item.grades.includes(grade));
      if (x) {
        return true;
      }
    })
  );
  return _.uniq(o.map((item) => item.name));
};

export default function BookTrial({ tutor, setBookTrial }: { tutor: ITutor; setBookTrial: any }) {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  // @ts-ignore
  const [boardOptions, setBoardOptions] = useState<string[]>([]);
  const [gradeOptions, setGradeOptions] = useState([]);
  const [subjectOptions, setSubjectOptions] = useState([]);
  const [hobbyOptions, setHobbyOptions] = useState<ITutorProfessionCategory<IHobby | ISkill>[] | undefined>();
  const [typeOptions, setTypeOptions] = useState<IHobbyType[] | ISkillType[]>([]);
  const [levelOptions, setLevelOptions] = useState<ILevels[]>([]);
  const { userData } = useAppSelector((state) => state.userSlice);
  const [category, setCategory] = useState<{
    board?: string;
    grade?: string;
    name: string;
    type?: string;
    level?: string;
  }>({
    name: '',
    board: '',
    grade: ''
  });
  const [slot, setSlot] = useState<Slot>();
  const [trialBooked, setTrialBooked] = useState(false);
  const [prevTrials, setPrevTrials] = useState<ITrialClass[]>([]);
  const [availableSlots, setAvailableSlots] = useState<ITimeSlot[]>([]);

  useEffect(() => {
    if (tutor.profession.data.categoryType === 'subject') {
      //@ts-ignore
      setBoardOptions(getBoards(tutor.profession.data.categories));
    }
  }, []);

  useEffect(() => {
    if (prevTrials) {
      const classesSlots = prevTrials.map((trial) => trial.scheduledTime);
      const calenderSlots = tutor.calender;
      const x = _.differenceBy(calenderSlots, classesSlots, 'start');
      setAvailableSlots(x);
    } else {
      setAvailableSlots(tutor?.calender || []);
    }
  }, [prevTrials]);

  useEffect(() => {
    if (userData?._id) {
      sessionsApi.get(userData._id, { type: 'trial' }).then((data) => setPrevTrials(data));
    }
  }, []);

  useEffect(() => {
    if (category.board) {
      // @ts-ignore
      let g = getGradesFromBoard(tutor.profession.data.categories, category.board);
      // @ts-ignore
      setGradeOptions(g);
      setCategory({
        ...category,
        grade: '',
        name: ''
      });
      setSubjectOptions([]);
    }
  }, [category.board]);

  useEffect(() => {
    if (category.board && category.grade) {
      // @ts-ignore
      let g = getSubjectsFromGrade(tutor.profession.data.categories, category.board, category.grade);
      // @ts-ignore
      setSubjectOptions(g);
      setCategory({
        ...category,
        name: ''
      });
    }
  }, [category.grade]);

  useEffect(() => {
    if (tutor.profession.data.categoryType === 'hobby' || tutor.profession.data.categoryType === 'skill') {
      setHobbyOptions(tutor.profession.data.categories);
    }
  }, [tutor.profession.data.categoryType]);

  useEffect(() => {
    if (category.name) {
      let hobby = hobbyOptions?.find((h) => h.name === category.name);
      if (hobby?.types && hobby.types.length > 0) {
        setTypeOptions(hobby.types);
      } else {
        setLevelOptions(hobby?.levels || []);
      }
    }
  }, [category.name]);

  useEffect(() => {
    if (category.type) {
      let type = typeOptions.find((t) => t.name === category.type);
      setLevelOptions(type?.levels || []);
    }
  }, [category.type]);

  const handleNext = () => {
    if (step === 1) {
      if (tutor.profession.data.categoryType === 'subject') {
        if (!category || !category.board || !category.grade || !category.name) {
          toast.error('Please Select all the options');
          return;
        }
      }

      if (tutor.profession.data.categoryType !== 'subject') {
        if (!category || !category.name || !category.level || (typeOptions.length > 0 && !category.type)) {
          toast.error('Please Select all the options');
          return;
        }
      }
      setStep(2);
      return;
    }
    if (step === 2) {
      if (!slot) {
        toast.error('Please select day and time for trial lesson');
        return;
      }
      if (!userData?._id) {
        navigate('/login');
      } else {
        const trial: AddPayload = {
          userId: userData._id,
          tutorId: tutor._id,
          category: category,
          type: 'trial',
          sessionDuration: 60,
          categoryType: tutor.profession.data.categoryType,
          scheduledTime: {
            ...slot
          }
        };
        setLoading(true);
        sessionsApi
          .add(userData._id, trial)
          .then(() => {
            setLoading(false);
            setTrialBooked(true);
          })
          .catch(() => {
            setLoading(false);
            toast.error('Exception: Something went wrong.');
          });
      }
    }
  };

  const handleStep1 = (value: any) => {
    tutor.profession.data.categoryType === 'subject'
      ? setCategory({
          ...category,
          board: value
        })
      : setCategory({
          ...category,
          name: value
        });
  };
  const handleStep2 = (value: any) => {
    tutor.profession.data.categoryType === 'subject'
      ? setCategory({
          ...category,
          grade: value
        })
      : typeOptions.length > 0
        ? setCategory({
            ...category,
            type: value
          })
        : setCategory({
            ...category,
            level: value
          });
  };
  const handleStep3 = (value: any) => {
    if (tutor.profession.data.categoryType === 'subject') {
      setCategory({
        ...category,
        name: value
      });
    } else {
      setCategory({ ...category, level: value });
    }
  };
  const handleStep4 = (value: any) => {
    setSlot(value);
  };

  if (trialBooked && slot) {
    return (
      <BottomSheet>
        <div className="w-full h-full flex flex-col p-10">
          {/* <MdClose onClick={() => setBookTrial(false)} className="ml-auto text-2xl cursor-pointer" /> */}
          <div className="w-full h-full max-w-lg mx-auto flex flex-col items-center justify-center gap-7">
            <img src={SUCCESS} className="w-20 h-20" />
            <h1 className="text-2xl font-semibold text-center">Your Trial Lesson was Booked Successfully.</h1>

            <div className="w-full flex flex-col gap-4 items-center">
              <h3 className="text-base font-medium">Trial lesson details</h3>
              <div className="w-full flex flex-col gap-2 items-center justify-center">
                <p className="text-sm font-semibold">
                  Tutor: <span className="font-medium">{tutor.personal.data.name}</span>
                </p>
                <p className="text-sm font-semibold capitalize">
                  {tutor.profession.data.categoryType}: <span className="font-medium">{category.name}</span>
                </p>
                <p className="text-sm font-semibold">
                  Date: <span className="font-medium">{format(parseJSON(slot.start), 'do MMMM yyyy')}</span>
                </p>
                <p className="text-sm font-semibold">
                  Time:{' '}
                  <span className="font-medium">
                    {format(parseJSON(slot.start), 'p')} - {format(parseJSON(slot.end), 'p')}
                  </span>
                </p>
              </div>
              <p className="text-xs text-neutralGray1 font-medium text-center">
                Note: Your booked trial details will be available under my calendar
              </p>
            </div>
            <div className="max-w-[200px]">
              <Button text="Book Another session" onClick={() => setBookTrial()} />
            </div>
          </div>
        </div>
      </BottomSheet>
    );
  }

  return (
    <BottomSheet>
      <div className="relative w-full h-full flex flex-col">
        <div className="sticky top-0 w-full flex items-center px-7 md:px-10 py-7 bg-white">
          {step === 2 && (
            <div className="w-full flex items-center">
              <MdKeyboardBackspace className="right-0 text-2xl cursor-pointer ml-auto" onClick={() => setStep(1)} />
              <h1 className="w-full mx-auto text-base md:text-xl text-center font-semibold">
                Select the day and time for your trial session
              </h1>
            </div>
          )}
          <MdClose className="right-0 text-2xl cursor-pointer ml-auto" onClick={() => setBookTrial(false)} />
        </div>

        <div className="w-full h-full md:w-4/5 mx-auto flex justify-center px-10 md:px-14 mb-32 overflow-y-scroll no-scrollbar">
          {tutor.profession.data.categoryType === 'subject' && step === 1 && (
            <div className="w-full flex flex-col gap-10">
              <div className="w-full flex flex-col gap-5">
                <h1 className="text-base md:text-xl font-semibold">Which board of education you are looking for ?</h1>
                <div className="w-full h-max flex flex-wrap items-stretch gap-4">
                  {boardOptions.map((item) => (
                    <Option key={item} label={item} name={category.board!} onClick={handleStep1} />
                  ))}
                </div>
              </div>

              {gradeOptions.length > 0 && (
                <div className="w-full flex flex-col gap-5">
                  <h1 className="text-base md:text-xl font-semibold">Which Grade are you looking for ?</h1>
                  <div className="w-full h-max flex flex-wrap items-stretch gap-4">
                    {gradeOptions.map((item) => (
                      <Option key={item} label={item} name={category.grade!} onClick={handleStep2} />
                    ))}
                  </div>
                </div>
              )}

              {subjectOptions.length > 0 && (
                <div className="w-full flex flex-col gap-5">
                  <h1 className="text-base md:text-xl font-semibold">Which subject you are looking for ?</h1>
                  <div className="w-full h-max flex flex-wrap items-stretch gap-4">
                    {subjectOptions.map((item) => (
                      <>
                        <Option
                          key={item}
                          label={item}
                          name={category.name}
                          onClick={handleStep3}
                          // change booktrial
                          disabled={prevTrials.find((x) => x.category.name === item) ? false : false}
                        />
                      </>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}

          {/* For hobby and skills */}
          {tutor.profession.data.categoryType !== 'subject' && step === 1 && (
            <div className="w-full flex flex-col gap-10">
              <div className="w-full flex flex-col gap-5">
                <h1 className="text-base md:text-xl font-semibold">{`Which ${tutor.profession.data.categoryType} are you looking for ?`}</h1>
                <div className="w-full h-max flex flex-wrap items-stretch gap-4">
                  {hobbyOptions &&
                    hobbyOptions.map((item) => (
                      <Option key={item.name} label={item.name} name={category.name!} onClick={handleStep1} />
                    ))}
                </div>
              </div>

              {typeOptions.length > 0 && (
                <div className="w-full flex flex-col gap-5">
                  <h1 className="text-base md:text-xl font-semibold">Which level are you looking for ?</h1>
                  <div className="w-full h-max flex flex-wrap items-stretch gap-4">
                    {typeOptions.map((item) => (
                      <Option key={item.name} label={item.name} name={category.type!} onClick={handleStep2} />
                    ))}
                  </div>
                </div>
              )}

              {levelOptions.length > 0 && (
                <div className="w-full flex flex-col gap-5">
                  <h1 className="text-base md:text-xl font-semibold">{`Which ${tutor.profession.data.categoryType} type are you looking for ?`}</h1>
                  <div className="w-full h-max flex flex-wrap items-stretch gap-4">
                    {levelOptions.map((item) => (
                      <>
                        <Option key={item} label={item} name={category.level!} onClick={handleStep3} disabled={false} />
                      </>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}
          {step === 2 && (
            <div className="w-full h-full max-h-[600px] flex flex-wrap items-stretch gap-4">
              <SelectSlot onSubmit={handleStep4} availableSlots={availableSlots} />
            </div>
          )}
        </div>

        <div className="absolute bottom-0 z-50 bg-white w-full flex items-center justify-center border-t border-neutralGray3 p-7 mt-auto">
          <div className="w-full max-w-[164px] mx-auto">
            <Button loading={loading} text={step === 2 ? 'Confirm' : 'Next'} block onClick={() => handleNext()} />
          </div>
        </div>
      </div>
    </BottomSheet>
  );
}

interface OptionsProps {
  label: string;
  name: string;
  onClick: (value: string) => void;
  disabled?: boolean;
}
const Option = ({ disabled, label, name, onClick }: OptionsProps) => {
  return (
    <div
      onClick={() => !disabled && onClick(label)}
      className={`${disabled ? 'opacity-50' : 'opacity-100 hover:border-primary cursor-pointer'} ${
        label === name ? 'bg-primary text-white' : 'bg-white text-primary'
      } w-full max-w-[128px] md:max-w-[164px] flex items-center justify-center border border-neutralGray3  p-4 md:p-7`}
    >
      <p className="text-sm text-center uppercase">{label}</p>
    </div>
  );
};

export interface Slot {
  start: string;
  end: string;
}

export const SelectSlot = ({
  onSubmit,
  availableSlots: a,
  tutorId
}: {
  onSubmit: any;
  availableSlots?: any;
  tutorId?: string;
}) => {
  const [selectedSlots, setSelectedSlots] = useState<ITimeSlot[]>([]);
  const [availableSlots, setAvailableSlots] = useState<ITimeSlot[]>(a);
  const { userData } = useAppSelector((state) => state.userSlice);
  const [classes, setClasses] = useState<ITrialClass[]>([]);

  useEffect(() => {
    onSubmit(selectedSlots[0]);
  }, [selectedSlots]);

  useEffect(() => {
    if ((a && a.length === 0) || !a) {
      if (tutorId) {
        xhr({
          method: 'GET',
          url: `/t/${tutorId}/available-slots`
        }).then((res) => {
          if (res.data.length > 0) {
            setAvailableSlots(res.data);
          }
        });
      }
    } else {
      setAvailableSlots(a);
    }
  }, []);

  useEffect(() => {
    if (userData?._id) {
      sessionsApi.get(userData._id).then((data) => {
        setClasses(data);
      });
    }
  }, []);

  return (
    <CalenderProvider>
      <Calender
        slotSelectable={true}
        bookedSlots={classes
          .filter((c) => c.status !== 'cancelled')
          .map((session) => ({
            status: session.status,
            tutor: session.tutor,
            type: session.type,
            category: session.category,
            slot: session.scheduledTime
          }))}
        availableSlots={availableSlots}
        selectedSlots={selectedSlots}
        onSelectSlot={(timeslot: ITimeSlot, remove?: number) => {
          if (remove) {
            setSelectedSlots(selectedSlots.filter((s) => s.start !== timeslot.start && s.end !== timeslot.end));
          } else {
            setSelectedSlots([timeslot]);
          }
        }}
      />
    </CalenderProvider>
  );
};
